/**
 * iaCorner.tsx
 */
import Direction from '@shared/types/enums/direction';
import Main from '@shared/types/enums/main';
import MainTemplate from '@components/templates/main/ui/main';
import useIACornerContent from '@shared/components/utils/hooks/useIACornerContent';
import useIACornerPromos from '@shared/components/utils/hooks/useIACornerPromos';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * IA Corner page component.
 * Main page component for displaying AI-generated corner content.
 * Fetches and displays both content (reels) and promos (highlights) for an IA Corner,
 * with pagination support for both horizontal and vertical navigation.
 *
 * @returns {JSX.Element} IA Corner page component
 */
export default function IACorner() {
  // Selectors
  const currentParams = useAppSelector(selectCurrentParams);

  // GraphQL hook: Rails
  const {
    complete: contentComplete,
    reels,
    onPagination: onContentPagination,
  } = useIACornerContent({
    id: currentParams?.id as string,
  });

  // GraphQL hook: Sliders
  const {
    complete: promosComplete,
    highlights,
    onPagination: onPromosPagination,
  } = useIACornerPromos({
    id: currentParams?.id as string,
  });

  // Render
  return (
    <MainTemplate
      flags={{ complete: contentComplete && promosComplete }}
      rails={reels}
      sliders={highlights}
      onPagination={(type: Main, direction: Direction) => {
        if (type === Main.RAILS) {
          onContentPagination(type, direction);
        } else if (type === Main.SLIDERS) {
          onPromosPagination();
        }
      }}
    />
  );
}
